

const dateTimeOptions = { 
	year: 'numeric',
	month: '2-digit',
	day: 'numeric',
	hour:'2-digit',
	minute:'2-digit'
}

const dateOptions = { 
	year: 'numeric',
	month: '2-digit',
	day: 'numeric',
}

const noYearOptions = {
	month: '2-digit',
	day: 'numeric',
}

const LocaleDate = ({date,includeTime=true,includeYear=true})=> {
	const string = (
		includeTime 
		? date.toLocaleString([],dateTimeOptions) 
		: (
			includeYear
			? date.toLocaleString([],dateOptions)
			: date.toLocaleString([],noYearOptions)
		)
	)
	return (
		string === 'Invalid Date'
		? ''
		: string
	)
}

export default LocaleDate